export default __webpack_public_path__ + "static/media/TA.24f40ba6.png";